<template>
  <div class="row">
    <div class="col-md-12">
      <b-form-group label="Destino">
        <b-form-input
          data-cy="destination"
          data-vv-as="destino"
          name="destination"
          type="text"
          v-model="destinationForm.destination"
          :state="errors.has('custom-document-part-2.destination') ? false : null"
          v-validate="'required'"
          maxLength="150"
        />
        <div
          v-if="errors.has('custom-document-part-2.destination')"
          class="con-text-validation span-text-validation-danger v-enter-to"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-2.destination') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6 text-center">
          <strong>Salida</strong>
        </div>
        <div class="col-md-6 text-center">
          <strong>Llegada</strong>
        </div>
        <div class="col-md-3 text-center">
          <b-form-group label="Hora">
            <b-form-input
              :state="errors.has('custom-document-part-2.departureTime') ? false : null"
              data-cy="departure-time"
              data-vv-as="hora"
              name="departureTime"
              v-model="destinationForm.departureTime"
              type="time"
              v-validate="{ required: !!destinationForm.mileageOutput.length }"
            />
            <div
              v-if="errors.has('custom-document-part-2.departureTime')"
              class="text-left con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document-part-2.departureTime') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3 text-center">
          <b-form-group label="Kilometraje">
            <b-input-group append="KM">
              <b-form-input
                :state="errors.has('custom-document-part-2.mileageOutput') ? false : null"
                data-cy="mileage-output"
                data-vv-as="km"
                name="mileageOutput"
                v-model="destinationForm.mileageOutput"
                type="number"
                :formatter="maxLength"
                v-validate="{ required: !!destinationForm.departureTime.length }"
              />
            </b-input-group>
            <div
              v-if="errors.has('custom-document-part-2.mileageOutput')"
              class="text-left con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document-part-2.mileageOutput') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3 text-center">
          <b-form-group label="Hora">
            <b-form-input
              :state="errors.has('custom-document-part-2.arrivalTime') ? false : null"
              data-cy="arrival-time"
              data-vv-as="hora"
              name="arrivalTime"
              v-model="destinationForm.arrivalTime"
              type="time"
              v-validate="{ required: !!destinationForm.mileageArrival.length }"
            />
            <div
              v-if="errors.has('custom-document-part-2.arrivalTime')"
              class="text-left con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document-part-2.arrivalTime') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3 text-center">
          <b-form-group label="Kilometraje">
            <b-input-group append="KM">
              <b-form-input
                :state="errors.has('custom-document-part-2.arrivalTime') ? false : null"
                data-cy="mileage-arrival"
                data-vv-as="km"
                name="mileageArrival"
                v-model="destinationForm.mileageArrival"
                type="number"
                :formatter="maxLength"
                v-validate="{ required: !!destinationForm.arrivalTime.length }"
              />
            </b-input-group>
          </b-form-group>
          <div
            v-if="errors.has('custom-document-part-2.mileageArrival')"
            class="text-left con-text-validation span-text-validation-danger v-enter-to"
          >
            <span class="span-text-validation">
              {{ errors.first('custom-document-part-2.mileageArrival') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 d-flex align-items-end justify-content-end">
      <b-button
        data-cy="add-destination-button"
        variant="primary"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        @click="addDestination()"
      >
        Agregar Destino
      </b-button>
    </div>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive';

export default {
  directives: {
    Ripple
  },
  data() {
    return {
      destinationForm: {
        destination: '',
        departureTime: '',
        arrivalTime: '',
        mileageOutput: '',
        mileageArrival: ''
      }
    };
  },
  methods: {
    maxLength(value) {
      return String(value).substring(0, 15);
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addDestination() {
      const isValid = await this.validateForm('custom-document-part-2');
      if (!isValid) {
        return;
      }

      if (!this.destinationForm.departureTime
        && !this.destinationForm.mileageOutput
        && !this.destinationForm.mileageArrival
        && !this.destinationForm.arrivalTime
      ) {
        this.$bvToast.toast(
          'Debes de agregar una salida y/o llegada',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        return;
      }

      const row = {
        destination: this.destinationForm.destination,
        departureTime: this.destinationForm.departureTime,
        arrivalTime: this.destinationForm.arrivalTime,
        mileageOutput: this.destinationForm.mileageOutput,
        mileageArrival: this.destinationForm.mileageArrival
      };

      this.$emit('add-destination', row);

      this.destinationForm.destination = '';
      this.destinationForm.departureTime = '';
      this.destinationForm.arrivalTime = '';
      this.destinationForm.mileageOutput = '';
      this.destinationForm.mileageArrival = '';

      await this.$validator.reset();
    }
  }
};
</script>
